/* ── Baby Joe Joe — Brand Animations JS ─────────────────────────────────── */

(function () {
  'use strict';

  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── 1. Page load: stagger top-level shopify sections ─────────────────── */
  function initPageLoad() {
    if (reduced) return;

    const sections = document.querySelectorAll(
      '#MainContent > .shopify-section'
    );

    sections.forEach(function (section, i) {
      section.classList.add('bjj-page-item');
      section.style.setProperty('--bjj-order', i);
    });
  }

  /* ── 2. Scroll reveal with IntersectionObserver ───────────────────────── */
  function initScrollReveal() {
    if (reduced || !('IntersectionObserver' in window)) {
      // Fallback: show everything immediately
      document.querySelectorAll('.bjj-reveal, .bjj-cascade').forEach(function (el) {
        el.classList.add('bjj-revealed');
      });
      return;
    }

    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('bjj-revealed');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );

    // Auto-tag sections and their key children for reveal
    document.querySelectorAll(
      '#MainContent > .shopify-section > section,' +
      '#MainContent > .shopify-section > div:not(.page-width)'
    ).forEach(function (el, i) {
      if (!el.classList.contains('bjj-reveal') && !el.classList.contains('bjj-cascade')) {
        el.classList.add('bjj-reveal');
        el.style.setProperty('--bjj-delay', (i % 4 * 60) + 'ms');
      }
      observer.observe(el);
    });

    // Observe explicitly tagged elements too
    document.querySelectorAll('.bjj-reveal, .bjj-cascade').forEach(function (el) {
      observer.observe(el);
    });
  }

  /* ── 3. Cart button success state ────────────────────────────────────── */
  function initCartButtons() {
    const ADD_TEXT    = null; // captured per button
    const SUCCESS_MS  = 2500;

    function attachToForm(form) {
      if (form.dataset.bjjCartBound) return;
      form.dataset.bjjCartBound = '1';

      const btn = form.querySelector('[name="add"], .product-form__submit');
      if (!btn) return;

      const originalText = btn.innerHTML;
      let timer = null;

      form.addEventListener('submit', function () {
        if (reduced) return;
        btn.classList.add('bjj-cart-btn--loading');
      });

      // Listen for Dawn's cart update events (PubSub)
      if (window.subscribe && window.PUB_SUB_EVENTS) {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
          onSuccess(btn, originalText, timer, SUCCESS_MS);
        });
      }

      // Fallback: listen for the custom event Dawn fires on the form
      form.addEventListener('product-form:error', function () {
        btn.classList.remove('bjj-cart-btn--loading');
      });

      document.addEventListener('cart:updated', function () {
        onSuccess(btn, originalText, timer, SUCCESS_MS);
      });
    }

    function onSuccess(btn, originalText, timer, ms) {
      btn.classList.remove('bjj-cart-btn--loading');
      btn.classList.add('bjj-cart-btn--success');
      btn.innerHTML = '<span class="bjj-check-icon">✓</span>En tu carrito';

      clearTimeout(timer);
      timer = setTimeout(function () {
        btn.classList.remove('bjj-cart-btn--success');
        btn.innerHTML = originalText;
      }, ms);
    }

    // Attach to all product forms now and watch for future ones (quick-buy etc.)
    document.querySelectorAll('product-form, form[action*="/cart/add"]').forEach(attachToForm);

    const mutationObs = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          const forms = node.querySelectorAll
            ? node.querySelectorAll('product-form, form[action*="/cart/add"]')
            : [];
          forms.forEach(attachToForm);
          if (
            node.matches &&
            (node.matches('product-form') || node.matches('form[action*="/cart/add"]'))
          ) {
            attachToForm(node);
          }
        });
      });
    });

    mutationObs.observe(document.body, { childList: true, subtree: true });
  }

  /* ── 4. Smooth page transition on internal links ─────────────────────── */
  function initPageTransitions() {
    if (reduced) return;

    document.addEventListener('click', function (e) {
      const a = e.target.closest('a[href]');
      if (!a) return;
      const href = a.getAttribute('href');
      // Only internal, non-hash, non-js links
      if (
        !href ||
        href.startsWith('#') ||
        href.startsWith('javascript') ||
        href.startsWith('mailto') ||
        href.startsWith('tel') ||
        a.target === '_blank' ||
        e.ctrlKey || e.metaKey || e.shiftKey
      ) return;

      try {
        const url = new URL(href, location.href);
        if (url.origin !== location.origin) return;
      } catch (_) { return; }

      e.preventDefault();
      document.documentElement.style.transition = 'opacity 0.22s ease';
      document.documentElement.style.opacity = '0';

      setTimeout(function () {
        window.location.href = href;
      }, 220);
    });

    // Fade back in on arrival
    window.addEventListener('pageshow', function () {
      document.documentElement.style.transition = 'opacity 0.3s ease';
      document.documentElement.style.opacity = '1';
    });
  }

  /* ── Init ────────────────────────────────────────────────────────────── */
  function init() {
    initPageLoad();
    initScrollReveal();
    initCartButtons();
    initPageTransitions();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
